/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
// tslint:disable:no-any

/**
 * A dummy/fake protocol which just forwards/bridges the data.
 * To be used with CrownConnectionProxy.
 */
export class CrownProtocolBridge {
  encode(data) {
    return data;
  }

  decode(data) {
    return data;
  }

}
//# sourceMappingURL=CrownProtocolBridge.js.map